import { render, staticRenderFns } from "./ApprovalDocumentCompany.vue?vue&type=template&id=0b11212e&scoped=true"
import script from "./ApprovalDocumentCompany.vue?vue&type=script&lang=js"
export * from "./ApprovalDocumentCompany.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDocumentCompany.vue?vue&type=style&index=0&id=0b11212e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11212e",
  null
  
)

export default component.exports